module.exports = __webpack_public_path__ + "static/media/pdv.ff47bc61.svg";